import { useMemo } from 'react';

import Flag from 'react-world-flags';

import { useIntl } from 'localization';
import { TOption } from 'ui/src/molecules/Dropdown/Dropdown';

import { useGetCountries } from './core/store/useGetCountries';

const useGetCountryOptions = () => {
  const intl = useIntl();

  const { data: countries, isLoading } = useGetCountries();
  const loc = useMemo(() => intl.locale.split('-')[0], [intl.locale]);
  let countryOptions: TOption[] = [];

  if (!isLoading) {
    countryOptions = Object.entries(countries || [])
      .map(([, value]) => ({
        icon: <Flag className="rounded-sm" width={20} height={24} code={value.countryCode} />,
        label: intl.formatMessage({ id: `cc.${value.countryCode}` }),
        value: value.countryCode,
      }))
      .sort((a, b) => a.label.localeCompare(b.label, loc));
  }

  return { countryOptions, isLoading };
};

export default useGetCountryOptions;
